import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/authentication.context';
import authService from '../../services/auth.service';

export default function ActivatAccountLandingPage(props) {
	let [failed, setFaild] = useState<boolean>(false);
	let [failureMessage, setFailureMesssage] = useState<string>('');
	let { token } = useParams();
	let navigate = useNavigate();
	let { setAuthenticated } = useAuth();

	const checkToken = async () => {
		if (!token) {
			setFaild(true);
			setFailureMesssage('Invalid URL. token is missing');
			return;
		}
		let response;
		try {
			response = await authService.activateAccount(token);
		} catch (e: any) {
			setFaild(true);
			setFailureMesssage(e.message);
			return console.error(e);
		}

		authService.setAccessToken(response.token);
		authService.setUserData(response.profile);
		setAuthenticated(true, response.token, response.profile);
		message.success('Welcome on board. Happy Hiring!', 5);
		navigate('/dashboard');
	};

	useEffect(() => {
		checkToken();
	}, []);

	return (
		<div>
			<p className="text-head--lg mt-5 text-center">{failed ? failureMessage : 'Please wait...'}</p>
		</div>
	);
}
